import styled from 'styled-components';

export const BottomButtonContainer = styled.div`
	width: 100%;
	max-width: 768px;
	padding: 15px 24px;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 12px;

	background-color: white;
`;

export const FolderItem = styled.li<{ isDragging: boolean }>`
	padding: 10px 20px;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	background-color: ${({ theme, isDragging }) =>
		isDragging ? theme['orange-secondary'] : theme['white-primary']};

	box-shadow: ${({ isDragging }) => (isDragging ? '0 2px 6px rgba(0,0,0,0.2)' : 'none')};
`;

export const FolderInfo = styled.div<{ isDragging: boolean }>`
	padding: 12px 14px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 2px;
	width: 100%;
	background-color: ${({ theme, isDragging }) =>
		isDragging ? theme['orange-quaternary'] : theme['white-primary']};
	border-radius: 10px;
`;

export const DragHandle = styled.div`
	padding: 16px;
	margin-right: -16px;
	cursor: grab;
`;
